import React from 'react';
import GrayShadowBox from '../../GrayShadowBox';
import Button from '../../Button';
import { formatPrice, getSiteName } from '../../../utils/productUtils';

const ProductBasicInfo = ({ 
    product, 
    editingPriceUsd, 
    tempPriceUsd, 
    onPriceUsdClick, 
    onPriceUsdSave, 
    onPriceUsdCancel, 
    onTempPriceUsdChange,
    onStatusChange,
    updatingStatus
}) => {
    const canChangeStatus = product.shopify_product_id && (product.status === 'draft' || product.status === 'active');
    const newStatus = product.status === 'draft' ? 'active' : 'draft';
    const statusButtonText = product.status === 'draft' ? '활성화로 변경' : '초안으로 변경';

    return (
        <GrayShadowBox>
            <h2 className="text-xl font-semibold text-gray-800 mb-4">기본 정보</h2>
            <div className="space-y-3">
                <div className="flex justify-between">
                    <span className="text-gray-600 font-medium">사이트</span>
                    <a
                        href={product.source_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:text-blue-800 hover:underline cursor-pointer"
                    >
                        {getSiteName(product.source_site)}
                    </a>
                </div>
                <div className="flex justify-between">
                    <span className="text-gray-600 font-medium">쇼피파이</span>
                    {product.shopify_product_id ? (
                        <a
                            href={`https://admin.shopify.com/store/hallyusuperstore19/products/${product.shopify_product_id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-blue-800 hover:underline cursor-pointer"
                        >
                            {product.status === 'draft' ? '쇼피파이 초안' : product.status === 'active' ? '쇼피파이 활성화' : product.status}
                        </a>
                    ) : (
                        <span className="text-gray-500">쇼피파이 미게시 항목</span>
                    )}
                </div>
                {canChangeStatus && onStatusChange && (
                <div className="flex justify-between">
                <span className="text-gray-600 font-medium">쇼피파이 상태 변경</span>
                        <Button
                            onClick={() => onStatusChange(newStatus)}
                            disabled={updatingStatus}
                            size="sm"
                            className={
                                product.status === 'draft' 
                                    ? "bg-yellow-200 hover:bg-yellow-500 text-yellow-800"
                                    : "bg-gray-300 hover:bg-gray-500 text-gray-800"
                            }
                        >
                            {updatingStatus ? '변경 중...' : statusButtonText}
                        </Button>
                </div>
                )}
                <div className="flex justify-between">
                    <span className="text-gray-600 font-medium">제품 ID</span>
                    <span className="text-gray-800 font-mono text-sm">{product.product_id}</span>
                </div>
                <div className="flex justify-between">
                    <span className="text-gray-600 font-medium">가격 (원화)</span>
                    <span className="text-gray-800 font-semibold">
                        {formatPrice(product.price)}
                    </span>
                </div>
                <div className="flex justify-between">
                    <span className="text-gray-600 font-medium">가격 (USD)</span>
                    {editingPriceUsd ? (
                        <div className="space-y-2">
                            <input
                                type="number"
                                value={tempPriceUsd}
                                onChange={(e) => onTempPriceUsdChange(e.target.value)}
                                className="px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-right"
                                placeholder="USD 가격을 입력하세요"
                                autoFocus
                                min="0"
                                step="0.01"
                            />
                            <div className="flex gap-2 justify-end">
                                <button
                                    onClick={onPriceUsdSave}
                                    className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700"
                                >
                                    저장
                                </button>
                                <button
                                    onClick={onPriceUsdCancel}
                                    className="px-3 py-1 bg-gray-500 text-white text-sm rounded hover:bg-gray-600"
                                >
                                    취소
                                </button>
                            </div>
                        </div>
                    ) : (
                        <span 
                            className="text-gray-800 font-semibold cursor-pointer hover:text-blue-600 underline decoration-dotted decoration-blue-400"
                            onClick={onPriceUsdClick}
                            title="클릭하여 편집"
                        >
                            ${product.price_usd || '0'}
                        </span>
                    )}
                </div>
                <div className="flex justify-between">
                    <span className="text-gray-600 font-medium">크롤링 일시</span>
                    <span className="text-gray-800 text-sm">
                        {product.crawled_at ? new Date(product.crawled_at).toLocaleString('ko-KR') : '-'}
                    </span>
                </div>
                <div className="flex justify-between">
                    <span className="text-gray-600 font-medium">업데이트</span>
                    <span className="text-gray-800 text-sm">
                        {product.updated_at ? new Date(product.updated_at).toLocaleString('ko-KR') : '-'}
                    </span>
                </div>
                {/* {canChangeStatus && onStatusChange && (
                        <Button
                            onClick={() => onStatusChange(newStatus)}
                            disabled={updatingStatus}
                            size="sm"
                            className="bg-slate-400 hover:bg-slate-700 text-white"
                        >
                            {updatingStatus ? '변경 중...' : statusButtonText}
                        </Button>
                    )} */}
            </div>
        </GrayShadowBox>
    );
};

export default ProductBasicInfo;
